import isNaN from '@/services/general/isNan';

export default function decimalsFormater(value) {
  const endChar = '0';
  const number = Number(value);
  if (isNaN(number)) {
    return Number(0).toFixed(2);
  }
  const value10 = number.toFixed(10);
  if (!value10.endsWith(endChar)) { return (value10); }
  const value9 = number.toFixed(9);
  if (!value9.endsWith(endChar)) { return (value9); }
  const value8 = number.toFixed(8);
  if (!value8.endsWith(endChar)) { return (value8); }
  const value7 = number.toFixed(7);
  if (!value7.endsWith(endChar)) { return (value7); }
  const value6 = number.toFixed(6);
  if (!value6.endsWith(endChar)) { return (value6); }
  const value5 = number.toFixed(5);
  if (!value5.endsWith(endChar)) { return (value5); }
  const value4 = number.toFixed(4);
  if (!value4.endsWith(endChar)) { return (value4); }
  const value3 = number.toFixed(3);
  if (!value3.endsWith(endChar)) { return (value3); }
  return number.toFixed(2);
}
